<template>
	<div v-if="sessionId" class="stripe-embedded-return">
		<div style="height:4px;">
			<v-progress-linear v-if="loading" indeterminate />
		</div>

		<div class="stripe-embedded-return__content" :class="computedClass">
			<div v-if="error" class="stripe-embedded-return__error">
				<slot name="error" v-bind="{ checkStatus }">
					<v-alert type="error" text outlined>
						<p>Could not check Stripe session status.</p>
						<v-btn @click="checkStatus">Try Again</v-btn>
					</v-alert>
				</slot>
			</div>

			<div v-else-if="status === 'complete' || status === 'paid'">
				<slot name="complete" v-bind="{ status }">{{ status }}</slot>
			</div>

			<div v-else-if="status">
				<slot name="incomplete" v-bind="{ status }">{{ status }}</slot>
			</div>
		</div>
	</div>
</template>

<script>
import QuilityAPI from '@/store/API/QuilityAPI.js'

export default {
    name: 'StripeCheckoutEmbeddedReturn',
    data: () => ({
		sessionId: null,
		status: '',
		loading: false,
		error: false,
    }),
	mounted () {
		this.checkStatus()
	},
	watch: {
		'$route.query' () {
			this.checkStatus()
		},
	},
	computed: {
		computedClass () {
			return [
				this.loading && 'content-loading',
			]
		},
	},
    methods: {
        async checkStatus () {
			this.sessionId = this.$route.query?.session_id
			if (!this.sessionId) { return }

			this.loading = true
			this.error = false
			try {
				const res = await QuilityAPI.getStripeSessionStatus(this.sessionId)
				this.status = res.status
			} catch (e) {
				this.error = true
				this.status = ''
				this.showError('Could not check Stripe session status.<br>', e)
			} finally {
				this.loading = false
				this.$emit('check-status', this.status)
			}
        },
    },
}
</script>

<style lang="scss" scoped>
.stripe-embedded-return {
	.stripe-embedded-return__content {
		transition: opacity 0.2sec;
		opacity: 1;
	}

	.stripe-embedded__error {
		text-align: center;
	}

	.content-loading {
		opacity: 0;
	}
}
</style>
